import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0be371b5"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "con-number"
}
const _hoisted_2 = {
  key: 1,
  class: "titlex"
}
const _hoisted_3 = {
  key: 2,
  class: "f-slot"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NFTCard = _resolveComponent("NFTCard")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{ only: _ctx.only }, "gridx"])
  }, [
    (_ctx.number)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.number), 1))
      : _createCommentVNode("", true),
    (_ctx.title)
      ? (_openBlock(), _createElementBlock("h3", _hoisted_2, _toDisplayString(_ctx.title), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass([[_ctx.notSelected], "flex flex-wrap con-nfts"])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nfts, (nft) => {
        return _withDirectives((_openBlock(), _createBlock(_component_NFTCard, {
          key: nft,
          nft: nft,
          info: _ctx.info,
          notSelected: _ctx.notSelected,
          onSelected: _ctx.handleSelected
        }, null, 8, ["nft", "info", "notSelected", "onSelected"])), [
          [_vShow, _ctx.staking ? _ctx.farmerState == 'staked' : _ctx.farmerState == 'pendingCooldown' || _ctx.farmerState == 'unstaked' ? true : _ctx.move]
        ])
      }), 128))
    ], 2),
    (_ctx.$slots.default)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}